import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getNotifications: {
    method: 'GET',
    url: `${configs.baseUrl}/api/notifications/`,
  },
  getCountNotificationUnread: {
    method: 'GET',
    url: `${configs.baseUrl}/api/notifications/count-unread/`,
  },
  readNotification: {
    method: 'POST',
    url: `${configs.baseUrl}/api/notifications/read-notification/`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getNotifications = async () => {
  const res = await resource.getNotifications()

  return res.body
}

const getCountNotificationUnread = async () => {
  const res = await resource.getCountNotificationUnread()
  return res.body
}

const readNotification = async (payload) => {
  const res = await resource.readNotification(payload)
  return res.body
}

export default {
  initResource,
  getNotifications,
  getCountNotificationUnread,
  readNotification,
}
